/*
 * Copyright 2019 Mozilla Inc. All Rights Reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/. 
 */

import XRAnchor from './XRAnchor';
import XRAnchorOffset from './XRAnchorOffset';
import XRFaceMesh from  './XRFaceMesh';
import XRHitTestResult from './XRHitTestResult';
import XRHitTestSource from './XRHitTestSource';
import XRTransientInputHitTestResult from './XRTransientInputHitTestResult';
import XRTransientInputHitTestSource from './XRTransientInputHitTestSource';
import XRImageAnchor from  './XRImageAnchor';
import XRLightProbe from './XRLightProbe';
import XRMesh from './XRMesh';
import XRPlaneMesh from './XRPlaneMesh';
import XRRay from './XRRay';
import XRVideoFrame from './XRVideoFrame';
import XRDOMOverlayState from './XRDOMOverlayState';

export default {
    XRAnchor,
    XRAnchorOffset,
    XRFaceMesh,
    XRHitTestResult,
    XRHitTestSource,
    XRTransientInputHitTestResult,
    XRTransientInputHitTestSource,
    XRImageAnchor,
    XRLightProbe,
    XRMesh,
    XRPlaneMesh,
    XRRay,
    XRVideoFrame, 
    XRDOMOverlayState
};